export function getByAlias(list, alias) {
    for (let id in list) {
        if (list.hasOwnProperty(id) && list[id].alias === alias) {
            return list[id];
        }
    }

    return null;
}


// WEBPACK FOOTER //
// ./src/js/selectors/common.js